import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
import { toMoney } from '../../../helpers/Format';
import { PaymentMethod } from '../../Reports/Model';
import React from 'react';
var BoxPaymentFormatter = function (_a) {
    var row = _a.row;
    return React.createElement(React.Fragment, null,
        React.createElement(Text, null, "".concat(T('total'), ": ").concat(toMoney(row.receipt_total / 100))),
        React.createElement(Text, { style: { marginBottom: row.boxPayments ? 0 : '1rem' }, color: 'green' }, "".concat(T('paid'), ": ").concat(toMoney(row.amount_paid / 100))),
        row.boxPayments.map(function (boxPayment, index, lista) {
            return React.createElement(React.Fragment, null,
                React.createElement(Text, { color: 'green', style: { marginLeft: 10, marginTop: 0, marginBottom: index === lista.length - 1 ? '1rem' : 0 } }, "".concat(T(boxPayment.method), ": ").concat(toMoney(boxPayment.amount)).concat(boxPayment.method === PaymentMethod.Credit && boxPayment.afiliate ? ' - ' + boxPayment.afiliate.name : '')));
        }),
        React.createElement(Text, { color: 'red' }, "".concat(T('unpaid'), ": ").concat(toMoney((row.receipt_total - row.amount_paid) / 100))));
};
var noBoxPaymentFormatter = function (row) {
    return React.createElement(React.Fragment, null,
        React.createElement(Text, null, "".concat(T('total'), ": ").concat(toMoney(row.receipt_total / 100))),
        React.createElement(Text, { style: { marginBottom: row.affiliate_company ? 0 : '1rem' }, color: 'green' }, "".concat(T('paid'), ": ").concat(toMoney(row.amount_paid / 100))),
        row.affiliate_company && React.createElement(Text, { style: { marginLeft: 10, marginTop: 0 }, color: 'green' }, "".concat(T(PaymentMethod.Credit), ": ").concat(toMoney(row.amount_paid / 100), " - ").concat(row.affiliate_company.name)),
        React.createElement(Text, { color: 'red' }, "".concat(T('unpaid'), ": ").concat(toMoney((row.receipt_total - row.amount_paid) / 100))));
};
var voucherPaymentFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (!row.boxPayments) {
        // no se ha pagado nada en destino, si hay amoun_paid es a credito
        return noBoxPaymentFormatter(row);
    }
    // si boxPayments es que los pagos están satisfechos
    return React.createElement(BoxPaymentFormatter, { row: row });
};
var csvNoBoxPaymentFormatter = function (row) {
    var result = '';
    result += "".concat(T('total'), ": ").concat(toMoney(row.receipt_total / 100));
    result += "".concat(T('paid'), ": ").concat(toMoney(row.amount_paid / 100));
    if (row.affiliate_company) {
        result += "".concat(T(PaymentMethod.Credit), ": ").concat(toMoney(row.amount_paid / 100), " - ").concat(row.affiliate_company.name);
    }
    result += "".concat(T('unpaid'), ": ").concat(toMoney((row.receipt_total - row.amount_paid) / 100));
    return result;
};
var csvBoxPaymentFormatter = function (row) {
    var result = '';
    if (!row.boxPayments) {
        return result;
    }
    result += "".concat(T('total'), ": ").concat(toMoney(row.receipt_total / 100));
    result += "".concat(T('paid'), ": ").concat(toMoney(row.amount_paid / 100));
    row.boxPayments.forEach(function (boxPayment) {
        result += "".concat(T(boxPayment.method), ": ").concat(toMoney(boxPayment.amount)).concat(boxPayment.method === PaymentMethod.Credit && boxPayment.afiliate ? ' - ' + boxPayment.afiliate.name : '');
    });
    result += "".concat(T('unpaid'), ": ").concat(toMoney((row.receipt_total - row.amount_paid) / 100));
    return result;
};
var csvVoucherPaymentFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (!row.boxPayments) {
        return csvNoBoxPaymentFormatter(row);
    }
    return csvBoxPaymentFormatter(row);
};
var voucherPaymentAfiliateNameFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row.affiliate_company) {
        return row.affiliate_company.name;
    }
    return 'FAREHARBOR';
};
var csvVoucherPaymentAfiliateNameFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row.affiliate_company) {
        return row.affiliate_company.name;
    }
    return 'FAREHARBOR';
};
var renderRowPayment = function (row, paymentMethod) {
    if (row.display_id === '#181206') {
        console.log('row: ', row);
    }
    if (!row.boxPayments) {
        // si hay pago es a credito
        if (row.amount_paid && paymentMethod === PaymentMethod.Credit) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Text, null, toMoney(row.amount_paid / 100))));
        }
        return null;
    }
    return (React.createElement(React.Fragment, null, row.boxPayments.map(function (boxPayment) {
        if (boxPayment.method === paymentMethod) {
            return React.createElement(Text, null, toMoney(boxPayment.amount));
        }
        return null;
    })));
};
var csvRenderRowPayment = function (row, paymentMethod) {
    if (!row.boxPayments) {
        // si hay pago es a credito
        if (row.amount_paid && paymentMethod === PaymentMethod.Credit) {
            return toMoney(row.amount_paid / 100);
        }
        return '';
    }
    var result = '';
    row.boxPayments.forEach(function (boxPayment) {
        if (boxPayment.method === paymentMethod) {
            result += toMoney(boxPayment.amount);
        }
    });
    return result;
};
var renderRowCreditPayment = function (row, paymentMethod) {
    if (!row.boxPayments) {
        // si hay pago es a credito
        if (row.amount_paid) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Text, null, toMoney(row.amount_paid / 100))));
        }
        return null;
    }
    return (React.createElement(React.Fragment, null, row.boxPayments.map(function (boxPayment) {
        if (boxPayment.method === paymentMethod) {
            return React.createElement(Text, null, toMoney(boxPayment.amount));
        }
        return null;
    })));
};
var csvRenderRowCreditPayment = function (row, paymentMethod) {
    if (!row.boxPayments) {
        // si hay pago es a credito
        if (row.amount_paid) {
            return toMoney(row.amount_paid / 100);
        }
        return '';
    }
    var result = '';
    row.boxPayments.forEach(function (boxPayment) {
        if (boxPayment.method === paymentMethod) {
            result += toMoney(boxPayment.amount);
        }
    });
    return result;
};
var csvVoucherPaymentMethodFormatter = function (paymentMethod, cell, row, rowIndex, formatExtraData) {
    switch (paymentMethod) {
        case PaymentMethod.Cash:
            return csvRenderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Card:
            return csvRenderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Transfer:
            return csvRenderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Other:
            return csvRenderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Credit:
            return csvRenderRowCreditPayment(row, paymentMethod);
            break;
        default:
            return '-';
    }
};
var voucherPaymentMethodFormatter = function (paymentMethod, cell, row, rowIndex, formatExtraData) {
    switch (paymentMethod) {
        case PaymentMethod.Cash:
            return renderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Card:
            return renderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Transfer:
            return renderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Other:
            return renderRowPayment(row, paymentMethod);
            break;
        case PaymentMethod.Credit:
            return renderRowCreditPayment(row, paymentMethod);
            break;
        default:
            return (React.createElement(Text, null, '-'));
    }
};
export { voucherPaymentMethodFormatter, voucherPaymentFormatter, voucherPaymentAfiliateNameFormatter, csvVoucherPaymentFormatter, csvVoucherPaymentMethodFormatter, csvVoucherPaymentAfiliateNameFormatter, };



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/helpers/vouchers.tsx
// module id = 1244
// module chunks = 0